import React, { memo } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const STATS = [
  { num: '8+',  unit: 'years',      label: 'Building production software for SMEs.'  },
  { num: '3+',  unit: 'multi-year', label: 'US clients still in active engagement.'  },
  { num: '100', unit: '%',          label: 'Founder involvement with every client.'  },
  { num: '3',   unit: 'regions',    label: 'US, Europe, and Middle East served.'     },
]

const OriginStory = () => {
  const data = useStaticQuery(graphql`
    query {
      tauseef: file(relativePath: { eq: "about/tauseef.png" }) {
        childImageSharp {
          fixed(width: 106, height: 106, quality: 95, cropFocus: ATTENTION) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return (
  <section className="os-section">
    <span className="os-eyebrow">THE TRUST WE'VE EARNED</span>
    <div className="os-inner">
      {/* ── Left: story ── */}
      <div className="os-left">
        <blockquote className="os-quote">
          No client has ever had to start over. The team that begins your project is the team that finishes it — because we engineered our company around finishing what we start.
        </blockquote>
        <p className="os-body">
          Visiomate was built on a frustration most business owners know: too many software development vendors that overpromise, underdeliver, and quietly die after months of invoices.
        </p>
        <p className="os-body">
          We don't deliver solutions. We deliver the outcomes our clients hired us to achieve — and we stay until those outcomes are real.
Today, we work with growing businesses across the US, Europe, and Middle East. Some of those relationships are now in their third year and still going.
        </p>
        <div className="os-author">
          <Img fixed={data.tauseef.childImageSharp.fixed} alt="Muhammad Tauseef" className="os-author__avatar" />
          <div className="os-author__name">
            <strong>Muhammad Tauseef Yunis Bhutti</strong>
            CEO &amp; Co-Founder, Visiomate
          </div>
        </div>
      </div>

      {/* ── Divider ── */}
      {/* <div className="os-divider" /> */}

      {/* ── Right: stat cards ── */}
      <div className="os-right">
        {STATS.map(({ num, unit, label }, i) => (
          <div key={i} className="os-stat-card">
            <span className="os-stat-card__value">
              {num}<span className="os-stat-card__unit">{unit}</span>
            </span>
            <span className="os-stat-card__label">{label}</span>
          </div>
        ))}
      </div>

    </div>
  </section>
  )
}

export default memo(OriginStory)
